export const postLog = async (level, message, properties) => {
  // let json = null;
  //const maxTries = 5;
  // const post = `{'level':'${level}','source':'detection-client-app','message':'${message}','userID': '${properties.userID}'}`;

  if (!properties) {
    properties = {};
  }

  // properties = {
  //   ...properties,
  //   application: "detect-clientapp",
  // };

  let postData = {
    level: level,
    message: message,
    //application: "detect-clientapp",
    properties: properties,
    //    ...properties,
  };

  // eslint-disable-next-line no-await-in-loop
  await fetch(`${process.env.REACT_APP_BASE_URL}/api/event`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(postData),
  })
    .then((response) => {
      if (response.ok) {
      }
    })
    .catch((error) => {
      // No logging. It might get into a loop.
      //          this.logger.error(`Error in Network: Error posting system info: ${id}`);
    });
};
